import { createModelSegment } from 'client/data/luckdragon/segment';
import { get, uniqBy } from 'lodash-es';
import { logger } from 'client/utils/logger/logger';
import { VisitorHistoryModel } from './visitor-history';

export const ReturnDashboardModel = createModelSegment('returnDashboard', [
  {
    path: 'recentlyViewed',
    async resolve(_, context) {
      const MAX_SIZE = 4;
      return context
        .resolveValue(
          `aggregatedHistory.vinAndModelAggregates.size["${MAX_SIZE}"].isVinOnly["false"].retries["no"].compact["true"]`,
          VisitorHistoryModel
        )
        .then(recentlyViewedData => {
          const { recentlyViewedVins, recentlyViewedMakeModels } = recentlyViewedData;

          const vins = recentlyViewedVins.map(({ vin, vehicleInfo: { styleInfo } }) => ({
            makeName: styleInfo?.make,
            modelName: styleInfo?.model,
            year: styleInfo?.year,
            vin,
          }));

          const makeModels = recentlyViewedMakeModels
            .filter(({ year }) => !!year)
            .map(({ year, makeName, modelName }) => ({
              makeName,
              modelName,
              year,
            }));

          return uniqBy(vins.concat(makeModels), ({ year, makeName, modelName }) => year + makeName + modelName).slice(
            0,
            MAX_SIZE
          );
        })
        .catch(err => {
          logger.warn(err);
          return [];
        });
    },
  },
  {
    path: 'aggregatedMakeModels',
    async resolve(_, context) {
      const MAX_SIZE = 4;
      return context.resolveValue('aggregatedHistory.withoutRetries', VisitorHistoryModel).then(userHistory =>
        uniqBy(
          get(userHistory, 'modelAggregates', []).filter(({ year }) => !!year),
          item => item.year + item.make + item.model
        ).slice(0, MAX_SIZE)
      );
    },
  },
]);
